import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { LanguageService } from "../services/language.service";

@Pipe({
  name: 'localizedDate',
  standalone: false,
  pure: false,
})
export class LocalizedDate implements PipeTransform {
    constructor(private languageService: LanguageService) {}
    transform(value: Date | null, format: string): string {
        return new DatePipe(this.languageService.getPreferredLanguage()).transform(value, format)?.toString() ?? '';
    }
}
